import ActiveFilters from './ActiveFilters';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import CardList from './CardList';
import Pagination from './Pagination';
import axios from 'axios';
import { useUser } from '../UserContext'; // Import the useUser hook
import { useParams, useOutletContext } from 'react-router-dom';

const MainPage = () => {

    const [ cards, setCards, currentPage, setCurrentPage, totalPages, setTotalPages ] = useOutletContext();
    const { user, setUser, selectedCard, setSelectedCard, filters, setFilters, settings, setSettings } = useUser();

    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);



    const [isLoading, setIsLoading] = useState(0);
    //const [cards, setCards] = useState([]);

      
    //   const [filters, setFilters] = useState({
    //     class: params.get('class') || '',
    //     cost: params.get('cost') || '',
    //     category: params.get('category') || '',
    //     cardtype: params.get('cardtype') || '',
    //     search: params.get('search') || '',
    //     startDate: params.get('startDate') || '',
    //     endDate: params.get('endDate') || '',
    //   });

    // useEffect(() => {
    //     const newFilters = {
    //         class: params.get('class') || '',
    //         cost: params.get('cost') || '',
    //         category: params.get('category') || '',
    //         cardtype: params.get('cardtype') || '',
    //         search: params.get('search') || '',
    //         startDate: params.get('startDate') || '',
    //         endDate: params.get('endDate') || '',
    //     };

    //     if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
    //         setFilters(newFilters);
    //     }
    // }, [location.search]);

    // useEffect(() => {
    //     setFilters({
    //       class: params.get('class') || '',
    //       cost: params.get('cost') || '',
    //       category: params.get('category') || '',
    //       cardtype: params.get('cardtype') || '',
    //       search: params.get('search') || '',
    //       startDate: params.get('startDate') || '',
    //       endDate: params.get('endDate') || '',
    //     });
    //   }, [location]);



    useEffect(() => {
        const newFilters = {
            class: params.get('class') || '',
            cost: params.get('cost') || '',
            attack: params.get('attack') || '',
            health: params.get('health') || '',
            rarity: params.get('rarity') || '',
            category: params.get('category') || '',
            cardtype: params.get('cardtype') || '',
            search: params.get('search') || '',
            startDate: params.get('startDate') || '',
            endDate: params.get('endDate') || '',
            order: params.get('order') || '',
        };

        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setCurrentPage(1);
            setFilters(newFilters);
        }
        setCurrentPage(parseInt(params.get('page'), 10) || 1);
    }, [location]);



    const handleCardClick = (card) => {
        setSelectedCard(card.id);
      };


      useEffect(() => {
        if (filters.length === 0) {
          return;
        }
        if (currentPage === 0) {
          return;
        }

        const fetchData = async (cancelToken) => {
          setIsLoading(1);
          try {
            const response = await axios.get(`/api/json_custom_react.php`, {
              params: {
                search: filters.search,
                page: currentPage,
                class: filters.class,
                mana: filters.cost,
                attack: filters.attack,
                health: filters.health,
                rarity: filters.rarity,
                deckid: filters.category,
                startDate: filters.startDate,
                endDate: filters.endDate,
                cardtype: filters.cardtype,
                language: settings.language,
                order: filters.order,
              },
              cancelToken: cancelToken.token,
            });
            setCards(response.data.cards);

            setTotalPages(response.data.main.maxpage); // Assuming your API returns the total number of pages
            setIsLoading(0);
            
            if (params.get('selectedCard') !== null && cards.length > 0) {
                //setSelectedCard(cards[0].id);
                params.set('selectedCard', response.data.cards[0].id);
                //navigate({ search: params.toString() }, { replace: true });
              }

          } catch (error) {
            if (axios.isCancel(error)) {
              console.log('Request canceled', error.message);
            } else {
              // handle error
            }
          }
        };

        // Create a new cancel token for the current request
        const cancelTokenSource = axios.CancelToken.source();
    
        // // Update URL with filters
        // const params = new URLSearchParams();
        // Object.entries(filters).forEach(([key, value]) => {
        //   if (value) {
        //     params.set(key, value);
        //   }
        // });
        // if (currentPage > 1) {
        //   params.set('page', currentPage);
        // }
    
        //  navigate({ search: params.toString() }, { replace: true });
    
        fetchData(cancelTokenSource);
    
        // Cancel the request if the effect is cleaned up
        return () => cancelTokenSource.cancel('Operation canceled due to new request.');
      }, [filters, currentPage, navigate, settings.language]);


    return (
        <>
<ActiveFilters filters={filters} handleRemoveFilter={(filterName) => {
    setFilters({ ...filters, [filterName]: '' });
    setCurrentPage(1);
  }} />
  <div style={{ opacity: isLoading ? '0.8' : '1' }}>
    <CardList cards={cards} loading={isLoading} settings={settings} />
  </div>
  <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
  </>
    );
};

export default MainPage;